import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { yup } from '@framework/validation/initYup.ts';

/** Shape condiviso del campo `decimalSize` (Number e Currency). */
export const decimalSizeConfigSchema = yup
  .number()
  .min(0)
  .notRequired()
  .nullable()
  .label('Numero massimo cifre decimali');

/**
 * Campo di configurazione "Numero massimo cifre decimali", condiviso da
 * Number e Currency: limita le cifre decimali digitabili nell'input
 * (`decimalPlaces` nei componenti form), senza generare errori di
 * validazione.
 */
export function DecimalSizeConfigInput() {
  return (
    <FormItem
      name="decimalSize"
      label="Numero massimo cifre decimali"
      help={
        <>
          Il <b>Numero massimo cifre decimali</b> limita le cifre decimali
          digitabili nel campo; non genera errori di validazione. Per un
          controllo con messaggio usare la regola «Numero massimo di cifre
          decimali».
        </>
      }
    >
      <NumberInput name="decimalSize" allowClear min={0} />
    </FormItem>
  );
}
